module.exports = __webpack_public_path__ + "img/gratis-ongkir.b4b08a52.svg";